import { Box } from '@mui/material';
import styled from 'styled-components';
import { colors } from '../../../theme';

export const SummaryBoxStyled = styled(Box)`
    && {
        background-color: ${colors.grey000};
        padding: 24px;
        border-radius: 8px;
        color: ${colors.grey200};
        box-shadow: 0px 10px 60px rgba(33, 22, 69, 0.04);
        margin-bottom: 24px;
        display: flex;
        padding: 24px;
        justify-content: center;
        align-items: center;
        align-content: center;
        gap: 38px;
        flex: 1 0 0;
        flex-wrap: wrap;
    }
`;

export const SummaryGroupStyled = styled.div`
    && {
        display: flex;
        height: 48px;
        align-items: center;
        gap: 24px;
    }
`;

export const SummaryElementStyled = styled.div`
    && {
        display: flex;
        height: 48px;
        align-items: center;
        gap: 24px;
    }
`;

export interface HotAlertHistoricButtonStyledProps {
    bgColor: string
    bgColorHover: string
    fontColor: string
    hasBoxShadow: boolean
    marginLeft?: boolean
}

export const HotAlertHistoricButtonStyled = styled(Box)((props : HotAlertHistoricButtonStyledProps) => `
    display: inline-flex;
    padding: 10px 21px;
    justify-content: center;
    align-items: center;
    gap: 10px;
    width: auto;
    min-width: 120px;
    color: ${props.fontColor};
    border-radius: var(--RADIUS, 8px);
    background: ${props.bgColor};
    box-shadow: ${props.hasBoxShadow ? '0px 4px 4px 10px 0px rgba(20, 119, 130, 0.30)' : 'none'};
    &:hover {
        background-color: ${props.bgColorHover};
        cursor: ${'pointer'};
        transition: background-color 500ms ease-in-out;
    }
    float: right;
    ${props.marginLeft ? 'margin-left: auto!important;' : ''}
`);
